import React, { useState } from "react";
import SaveButton from "../../../components/Buttons/SaveButton";
import SelectListField from "../../../components/Fields/SelectListField";
import { FormConfig } from "../../../components/Fields/Types";
import useSelectListOptions from "../../../components/Hooks/SelectListOptionsHook/useSelectListOptions";
import useValidation from "../../../components/Hooks/ValidationHook/useValidation";
import Popup from "../../../components/Popups/Popup";
import { useNotifications } from "../../../contexts/notificationContext";
import DataService from "../../../services/data.service";
import { ItemItemRevisionPopupProps } from "../../../types/PopupProps";
import { Result } from "../../../types/Result";

interface ItemBusinessPartnerModel {
    itemId: number
    itemRevisionId: number
    businessPartnerTypeId?: number
    businessPartnerId?: number
    contactPersonId?: number
    employeeId?: number
}

const AddBusinessPartnerPopup: React.FC<ItemItemRevisionPopupProps> = ({ show, onHide, itemId, itemRevisionId }) => {
    const [serverErrors, setServerErrors] = useState<Result>({ isSuccesful: true, messages: []});
    const { handleResult, handleException } = useNotifications();

    const [formData, setFormData] = useState<ItemBusinessPartnerModel>({
        itemId: itemId,
        itemRevisionId: itemRevisionId,
    });

    const businessPartnerTypes = useSelectListOptions('api/v1/selectlist/businessPartnerTypes?activeOnly=true', '-- Select businesspartner type');
    const businessPartners = useSelectListOptions('api/v1/selectlist/businessPartners?activeOnly=true&businessPartnerTypeId=' + formData.businessPartnerTypeId, '-- Select business partner');
    const contactPersons = useSelectListOptions('api/v1/selectlist/contactpersons?activeOnly=true&businessPartnerId=' + formData.businessPartnerId, '-- Select contactperson')

    function submit() {
        if (formData) {
            DataService
                .create<ItemBusinessPartnerModel>(`api/v1/ItemBusinessPartners`, formData)
                .then(response => {
                    handleResult(response);
                    setServerErrors(response);
                    if (response.isSuccesful === true) {
                        onHide();
                    }
                })
                .catch(e => handleException(e));
        }
    }

    const formConfig: FormConfig = {
        fields: [
            { name: 'businessPartnerTypeId', label: 'Business partner type', labelSize: 4, validationRules: [{ type: 'isRequired' }] },
            { name: 'businessPartnerId', label: 'Business partner', labelSize: 4, validationRules: [{ type: 'isRequired' }] },
            { name: 'contactPersonId', label: 'Contactperson', labelSize: 4 },
        ],
        handleSubmit: submit,
        showErrors: 'always',
    };

    const { getFieldProps, getSubmitButtonProps } = useValidation(formConfig, formData, serverErrors);

    return (
        <Popup show={show} onHide={onHide} size={'lg'} title={'Add business-partner'} >
            <Popup.Body>
                <SelectListField {...getFieldProps('businessPartnerTypeId')} options={businessPartnerTypes} />
                <SelectListField {...getFieldProps('businessPartnerId')} options={businessPartners} />
                <SelectListField {...getFieldProps('contactPersonId')} options={contactPersons} />
            </Popup.Body>
            <Popup.Footer>
                <SaveButton {...getSubmitButtonProps()} text='Add' />
            </Popup.Footer>
        </Popup>
    );
}
export default AddBusinessPartnerPopup;